export function avgAggFunction(params) {
	// the average will be the sum / count
	var sum = 0;
	var count = 0;

  params.values.forEach(function (value) {
		var groupNode =
			value !== null && value !== undefined && typeof value === 'object';

		if (groupNode) {
			// we are aggregating groups, so we take the
			// aggregated values to calculated a weighted average
			sum += value.avg * value.count;
			count += value.count;
		} else {
			// skip values that are not numbers (ie skip empty values)
			var num = parseFloat(value);

			if (!isNaN(num)) {
				sum += num;
				count++;
			}
		}
	});

	// avoid divide by zero error
	if (count !== 0) {
		var avg = sum / count;
	} else {
		avg = null;
	}

	// the result will be an object. when this cell is rendered, only the avg is shown.
	// however when this cell is part of another aggregation, the count is also needed
	// to create a weighted average for the next level.
	var result = {
		count: count,
		avg: avg,
		// the grid by default uses toString to render values for an object, so this
		// is a trick to get the default cellRenderer to display the avg value
		toString: function () {
			return (this.avg == null) ? '0.00' : this.avg.toFixed(2);
		},
	};

	return result;
}
